import WindowHelper from "~/ts/library/WindowHelper";

export const LCAB_LAYOUT_BREAKPOINT = 767;

export default class LcabWindowHelper extends WindowHelper {

    public static isMobile() {
        return this.getSize().width < LCAB_LAYOUT_BREAKPOINT;
    }
}